import { render } from "./Profesionales.vue?vue&type=template&id=177a2c82&ts=true"
import script from "./Profesionales.vue?vue&type=script&lang=ts"
export * from "./Profesionales.vue?vue&type=script&lang=ts"

import "./Profesionales.vue?vue&type=style&index=0&id=177a2c82&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__